import Layout from '@layout/Index'

export const workInfoCompany = [
  {
    path: '/work-info-company',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "WorkInfoCompanyTable" */ './pages/WorkInfoCompanyTable.vue'),
        name: '职业信息公司',
        meta: {
          title: '职业信息公司',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "WorkInfoCompanyForm" */ './pages/WorkInfoCompanyForm.vue'),
        name: '新增职业信息公司',
        meta: {
          title: '新增职业信息公司',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "WorkInfoCompanyForm" */ './pages/WorkInfoCompanyForm.vue'),
        name: '编辑职业信息公司',
        meta: {
          title: '编辑职业信息公司',
        },
      },
    ],
  },
]




// WEBPACK FOOTER //
// ./src/views/work-info-company/work-info-company.route.js